import type { variantConfig } from '~/components/ui/Badge/variants'

export const mapKajStatus = (status: string | number) => {
  const statusMap = {
    finish: [201, 200],
    cancel: [300, 350],
    pending: [100, 110, 905],
    pending_pickup: [105],
    shipment: [106],
    return: [400, 401, 402]
  }

  const statusLabel: Record<keyof typeof statusMap, string> = {
    finish: 'Tiba di Tujuan',
    cancel: 'Dibatalkan',
    pending: 'Menunggu',
    pending_pickup: 'Menunggu Pickup',
    shipment: 'Sedang Dikirim',
    return: 'Retur'
  }

  const statusColor: Record<
    keyof typeof statusMap,
    keyof typeof variantConfig
  > = {
    finish: 'successContainer',
    cancel: 'errorContainer',
    pending: 'secondaryContainer',
    pending_pickup: 'warningContainer',
    shipment: 'primaryContainer',
    return: 'warningContainer'
  }

  const matchStatus = Object.entries(statusMap).find(([, value]) =>
    value.includes(Number(status))
  )
  return {
    label:
      statusLabel[matchStatus?.[0] as keyof typeof statusLabel] || 'Menunggu',
    color:
      statusColor[matchStatus?.[0] as keyof typeof statusColor] ||
      'secondaryContainer'
  }
}
